import { IGroup } from "./IGroup";

export class group_api {

    public static save:string = "/api/group/save"
    public static find_by_id:string = "/api/group/find_by_id"
    public static find_all:string = "/api/group/find_all"
    public static find_by_filter:string = "/api/group/find_by_filter"
    public static del:string = "/api/group/del"

}

export interface IGroupSvc {

    save(group:IGroup):Promise<IGroup | undefined>;
    find_by_id(group_id:string):Promise<IGroup | undefined>;
    find_by_filter(filter:any):Promise<IGroup[]>;
    find_all():Promise<IGroup[]>;
    del(_id:any):Promise<boolean>;

}